import { Select } from "antd";
import React, { useState } from "react";
import trans from "../../utils";

export default function DropdownInput({
	id,
	item,
	preview,
	addData,
	submitData,
	setSubmitData,
	readOnly,
}) {
	const [value, setValue] = useState(null);
	const currentValue = addData
		? submitData?.find((i) => i.key === item.key)?.value ?? undefined
		: item?.value ?? value ?? undefined;
	const validate = addData
		? addData?.touched?.fields?.[item?.key]?.value &&
		  item?.required?.value &&
		  currentValue === undefined
		: item?.required?.value && currentValue === undefined;
	const styleValidate = addData
		? addData?.touched?.fields?.[item?.key]?.value &&
		  item?.required?.value &&
		  currentValue === undefined
		: preview !== true && currentValue === undefined && item?.required?.value;

	return (
		<div style={item?.css}>
			<label
				htmlFor={id}
				className="form-label d-flex align-items-center"
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
			>
				<div>{item?.title}</div>
				{item?.required?.value && value === null && (
					<div className="text-danger ms-2">*</div>
				)}
			</label>
			<Select
				allowClear={!readOnly}
				style={{
					width: "100%",
				}}
				status={styleValidate ? "error" : ""}
				placeholder={item?.placeholder}
				options={item?.dropdownOptions?.data}
				value={currentValue}
				disabled={readOnly}
				onChange={(e) => {
					const newValue = e;
					setValue(newValue);
					if (addData) {
						setSubmitData((prev) => {
							// Remove existing item with same key if you want to replace it
							const filtered = prev?.filter((i) => i.key !== item.key) || [];
							return [
								...filtered,
								{
									key: item.key,
									name: item.name,
									title: item.title,
									value: newValue,
								},
							];
						});

						addData.setFieldTouched(`fields[${item.key}].value`, true);
					}
				}}
				onBlur={() => {
					if (addData) {
						addData.setFieldTouched(`fields[${item?.key}].value`, true);
					}
				}}
			/>
			{preview !== true ? (
				<>
					{validate && (
						<div className="text-danger mt-1">
							{trans(item?.required?.validationMessage)}
						</div>
					)}
				</>
			) : (
				""
			)}
		</div>
	);
}
